// src/TermsOfUsePublic.jsx
//
// Página pública (rota /termos-de-uso) que exibe os Termos de Uso e
// Privacidade em modo somente-leitura. Sem aceite, sem fluxo de
// cadastro, sem chamada a /registration/complete.
//
// Linkada via e-mail de broadcast quando os Termos forem atualizados
// (functions/scripts/_broadcast_terms_update.js), para que clientes
// já cadastrados possam ler os novos Termos sem precisar reaceitar
// dentro da sessão.
//
// O design segue o shell compartilhado LegalPageShell, harmonizado
// com o restante do app (Cormorant Garamond na headline, paleta da
// marca, eyebrow art-déco).

import React from 'react';
import LegalPageShell from './components/LegalPageShell';
import TermsOfUseContent from './terms/TermsOfUseContent';
import { TERMS_OF_USE_VERSION } from './terms/termsVersion';
import PageSeo from './seo/PageSeo';

const TermsOfUsePublic = () => (
  <>
  <PageSeo
    path="/termos-de-uso"
    title="Termos de Uso e Privacidade — Consulta+"
    description="Termos de Uso e Privacidade da Consulta+: contrato de prestação do serviço de teleconsulta médica online por chat, validade dos documentos emitidos (receita, atestado, pedido de exame em PDF com ICP-Brasil) e regras de uso da plataforma."
    breadcrumbs={[
      { name: 'Início', url: '/' },
      { name: 'Termos de Uso', url: '/termos-de-uso' },
    ]}
  />
  <LegalPageShell
    eyebrow="Documento legal"
    title="Termos de Uso e Privacidade"
    subtitle={`Consulta+ — versão ${TERMS_OF_USE_VERSION}`}
    contactEmail="atendimento@consultamais.app"
  >
    <TermsOfUseContent />
  </LegalPageShell>
  </>
);

export default TermsOfUsePublic;
